module.exports = __webpack_public_path__ + "img/lingnanyingxiangyuan.c5ac3645.jpg";